import React from 'react';
import { Link } from 'react-router-dom';
import { TModalProps } from 'modules/types';
import { ERoute } from 'enums/route.enum';
import { Modal } from 'antd';
import { Button } from 'antd';
import styled from 'styled-components';
import { SecondaryColor } from 'GlobalStyles';

const AcceptanceRedirectmodal = ({ modalState, setModalState }: TModalProps) => {
  const handleCancel = () => {
    setModalState({ visible: false });
  };

  return (
    <AcceptanceRedirectmodalWrapper>
      <Modal
        className='normal-modal-container'
        visible={modalState.visible}
        centered={true}
        maskClosable={true}
        closable={true}
        width={540}
        onCancel={handleCancel}
        title={
          <div style={{ marginTop: '20px' }}>
            <span
              style={{
                fontSize: '1.75rem',
                fontWeight: 'bolder',
              }}
            >
              후기 등록 안내
            </span>
          </div>
        }
        footer={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={handleCancel}>취소</Button>
            <Link to={ERoute.FinalAcceptanceWrite.replace(':operation', 'create')}>
              <Button className='ant-btn-primary'>최종합격후기로 이동하기</Button>
            </Link>
          </div>
        }
      >
        <div className='modal-body'>
          <div className='modal-desciption'>
            <p>멘티님은 최종합격후기 등록 대상자입니다!</p>
            <p>최종합격후기를 작성하고 경품인 엑셀강의영상을 통해 일잘러가 되어보세요</p>
            <p style={{ color: SecondaryColor }}>*최종합격후기는 추첨이 아닌 100% 확률로 경품이 지급됩니다</p>
          </div>
          <div className='modal-desciption-small'>
            <p>멘티님은 최종합격후기 등록 대상자입니다!</p>
            <p>최종합격후기를 작성하고 경품인 </p>
            <p>엑셀강의영상을 통해 일잘러가 되어보세요</p>
            <div style={{ color: SecondaryColor }}>
              <p>*최종합격후기는 추첨이 아닌 </p>
              <p>100% 확률로 경품이 지급됩니다</p>
            </div>
          </div>
        </div>
      </Modal>
    </AcceptanceRedirectmodalWrapper>
  );
};

export default AcceptanceRedirectmodal;

const AcceptanceRedirectmodalWrapper = styled.div``;
